import { call, put, select } from 'redux-saga/effects';
import { selectPollEntities } from 'features/polls/pollsSlice';
import { pollResultsCleared } from 'features/polls/actions';
import { closeActionNotification } from 'features/notifications/thunks/closeActionNotification';
import { PollEntities } from 'features/polls/types';
import { Action } from '@reduxjs/toolkit';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';

export function* clearPollsSaga() {
  const entities: PollEntities = yield select(selectPollEntities);

  for (const poll of Object.values(entities)) {
    if (poll.active) {
      const notificationThunk: Action = yield call(
        closeActionNotification,
        `poll_request_vote_${poll.id}`
      );
      yield put(notificationThunk);
    }
  }

  const canManagePolls: boolean = yield call(hasPermissionsSaga, PermissionTypes.managePolls);

  yield put(pollResultsCleared({ canManagePolls }));
}
